import { Button } from "primereact/button";
import React, { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { CourseDetailOverview } from "./CourseDetailOverview";
import { CourseDetailLive } from "./CourseDetailLive";

export const CourseDetailOverviewMobile = ({ courseItemData }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <div className="course-detail-overview-mobile flex justify-content-between align-items-center fixed bottom-0 w-full">
        <div>
          <div className="flex align-items-center">
            <p className="font-size-16 font-weight-400 line-height-24 m-0 select-none line-through gray-color">2,000,000</p>
            <div className="bg-alice-blue p-1 ml-1">
              <p className="font-weight-500 font-size-14 line-height-20 primary-color m-0">-56%</p>
            </div>
          </div>
          <h4 className="default-text font-size-24 font-weight-400 line-height-32 m-0">1,150,000 đ</h4>
        </div>
        <Button className="bg-primary" icon="pi pi-angle-up" label="Chi tiết" onClick={() => setVisible(true)} />
      </div>
      <Sidebar className="course-detail-overview-mobile-sidebar" visible={visible} position="bottom" onHide={() => setVisible(false)}>
        <CourseDetailOverview courseItemData={courseItemData} />
        <CourseDetailLive style={{ marginTop: "1.5rem" }} />
      </Sidebar>
    </div>
  );
};
